import React, { useState, useContext } from "react";
import {
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import AlertPOP from "../../../../routes/AlertPOP";
import validator from "validator";
import axios from "axios";
import baseUrl from "../../../../BaseURL";
import Professons from "./Professons";
import nigeriaStates from "./nigeriaStates";
import { ContextData } from "../../../../context/Context";
import { StatesData } from "./StatesData";
import { toast } from "react-toastify";

import { registrationCountries as countries } from "./registrationOptions";

const initialFormData = {
  firstName: "",
  lastName: "",
  gender: "",
  email: "",
  mobileNumber: "",
  origin: "",
  country: "",
  stateOfOrigin: "",
  lga: "",
  stateofresident: "",
  other_state: "",
  other_profession: "",
  dateOfBirth: "",
  nin: "",
  profession: "",
  position: "",
  member_address: "",
  department: "",
  m_status: "",
};

export default function FormMember({ from }) {




  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [transition, setTransition] = useState(undefined);
  const [formData, setFormData] = useState(initialFormData);
  const [LGAlist, setLGAlist] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const {
    setRefreshAmount,
    RefreshAmount,
    accesstoken,
    Person,
    Refresh,
    setRefresh,
    compressedImage,
    setCompressedImage,
    compressedNINImage,
    setCompressedNINImage,
  } = useContext(ContextData);

  // Alert handlers
  const handleClick = (Transition) => {
    setTransition(() => "TransitionLeft");
    setOpenAlert(true);
  };
  const handleCloseAlert = () => setOpenAlert(false);

  // Form field change handler
  const handleInputChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (field === "stateOfOrigin") {
      const selectedState = StatesData.find((s) => s.state === value);
      setLGAlist(selectedState ? selectedState.lgas : []);
    }
  };

  // Select field change handlers
  const handleSelectChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleCitizenshipTypeChange = (e) => {
    const selectedOriginType = e.target.value;
    setFormData((prev) => ({
      ...prev,
      origin: selectedOriginType,
      country: selectedOriginType === "indigene" ? "Nigeria" : "",
      stateOfOrigin: "",
      stateofresident: "",
      other_state: "",
    }));
    setLGAlist([]);
  };

  // Form submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const currentYear = new Date().getFullYear();

    // Required fields validation
    const requiredFields = [
      "firstName", "lastName", "email", "mobileNumber", "origin", "country",
      "dateOfBirth", "nin", "profession", "position", "m_status",
    ];

    for (const field of requiredFields) {

      if (validator.isEmpty(formData[field]?.trim() || "")) {
        handleClick("left");
        setMessage("Please fill out all fields");
         playSound("error")
          toast.error("Please fill out all fields", {
          position: "top-center",    
          autoClose: 5000,
          hideProgressBar: false, 
          closeOnClick: true,
          pauseOnHover: true, 
          draggable: true,
          progress: undefined,
        });
        return;
      }
    }
    if (!validator.isNumeric(formData.mobileNumber.trim())) {
      handleClick("left");
      setMessage("Mobile is not a number");
      playSound("error")
      toast.error("Mobile is not a number", {
        position: "top-center",    
        autoClose: 5000,
        hideProgressBar: false, 
        closeOnClick: true,
        pauseOnHover: true, 
        draggable: true,
        progress: undefined,
      });

      return;
    }
    if (!validator.isEmail(formData.email.trim())) {
      handleClick("left");
      setMessage("Email is not valid");
      playSound("error")
      toast.error("Email is not valid", {
        position: "top-center",    
        autoClose: 5000,
        hideProgressBar: false, 
        closeOnClick: true,
        pauseOnHover: true, 
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (validator.isEmpty(compressedImage.trim())) {
      handleClick("left");
      setMessage("Capture Member Image");
      playSound("error")
      toast.error("Capture Member Image", {
        position: "top-center",    
        autoClose: 5000,
        hideProgressBar: false, 
        closeOnClick: true,
        pauseOnHover: true, 
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (formData.nin !== "N/A" && validator.isEmpty(compressedNINImage.trim())) {
      handleClick("left");
      setMessage("Capture NIN Image");
      playSound("error")
      toast.error("Capture NIN Image", {
        position: "top-center",    
        autoClose: 5000,
        hideProgressBar: false, 
        closeOnClick: true,
        pauseOnHover: true, 
        draggable: true,
        progress: undefined,
      });
      return;
    }

    // Age calculation
    const birthYear = parseInt(formData.dateOfBirth.slice(0, 4), 10);
    const age = currentYear - birthYear;
    const data = {
      ...formData,
      age,
      registerer_token: Person?.token || "",
    };

    
    // Prepare FormData for submission
    const formDataObj = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formDataObj.append(key, value);
    });
    formDataObj.append("memberfile", await (await fetch(compressedImage)).blob());
    formDataObj.append("ninfile", await (await fetch(compressedNINImage)).blob());
    formDataObj.append("from", from);

    // Submit form
    setSubmitting(true);
    try {
      const res = await axios.post(`${baseUrl}/auth/registermember`, formDataObj, {
        withCredentials: true,
        headers: {
          Accept: "application/json",
          authorization: `Bearer ${accesstoken || ""}`,
        },
      });
      handleClick("left");
      
     
      if (res.data.status) {
        setSubmitting(false);
        setMessage(res.data.statusText);
        setRefresh((r) => !r);
        setFormData(initialFormData);
        setCompressedImage("");
        setCompressedNINImage("");
        setRefreshAmount((r) => !r);
        playSound("success")
        toast.success(res.data.statusText, {
          position: "top-right",    
          autoClose: 5000,
          hideProgressBar: false, 
          closeOnClick: true,
          pauseOnHover: true, 
          draggable: true,
          progress: undefined,
        });
      }else {
        setMessage(res.data.statusText);
        setSubmitting(false);
         playSound("error")
        toast.error(res.data.statusText, {
          position: "top-center",    
          autoClose: 5000,
          hideProgressBar: false, 
          closeOnClick: true,
          pauseOnHover: true, 
          draggable: true,
          progress: undefined,
        });
      }

    } catch (err) {
      handleClick("left");
      setMessage(err.message);
      setSubmitting(false);
    }
  };

  
 const playSound = (status) => {

    if (status === "success") {

      const audio = new Audio('/assets/sound1.mp3');
      audio.play().catch(error => {
        console.error("Playback failed:", error);
      });
      
    }else if (status === "error") {

      const audio = new Audio('/assets/sound2.mp3');
      audio.play().catch(error => {
        console.error("Playback failed:", error);
      });
    }

  };

  return (
    <>
      <AlertPOP
        Open={openAlert}
        handleClose={handleCloseAlert}
        transition={transition}
        message={message}
      />
      <form onSubmit={handleSubmit}>
        <TextField
          label="First Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.firstName}
          onChange={handleInputChange("firstName")}
        />
        <TextField
          label="Last Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.lastName}
          onChange={handleInputChange("lastName")}
        />
        <TextField
          select
          label="Marital Status"
          variant="outlined"
          fullWidth
          name="m_status"
          margin="normal"
          value={formData.m_status}
          onChange={handleSelectChange("m_status")}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="single">Single</MenuItem>
          <MenuItem value="married">Married</MenuItem>
          <MenuItem value="widow">Widow</MenuItem>
          <MenuItem value="widower">Widower</MenuItem>
        </TextField>
        <TextField
          select
          label="Gender"
          variant="outlined"
          fullWidth
          name="gender"
          margin="normal"
          value={formData.gender}
          onChange={handleSelectChange("gender")}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="male">Male</MenuItem>
          <MenuItem value="female">Female</MenuItem>
        </TextField>
        <TextField
          select
          label="Department"
          variant="outlined"
          fullWidth
          name="department"
          margin="normal"
          value={formData.department}
          onChange={handleSelectChange("department")}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="Mother Body">Mother Body</MenuItem>
          <MenuItem value="First Aid">First Aid</MenuItem>
          <MenuItem value="Women Wing">Women Wing</MenuItem>
        </TextField>
        <TextField
          label="Email"
          type="email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.email}
          onChange={handleInputChange("email")}
        />
        <TextField
          label="Mobile Number"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.mobileNumber}
          onChange={handleInputChange("mobileNumber")}
        />
        <TextField
          select
          label="Nationality"
          variant="outlined"
          fullWidth
          name="origin"
          margin="normal"
          value={formData.origin}
          onChange={handleCitizenshipTypeChange}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem selected value="indigene">Indigene</MenuItem>
          <MenuItem disabled value="citizen">Citizen</MenuItem>
        </TextField>
        <TextField
          select
          label="Country of Origin"
          variant="outlined"
          fullWidth
      
          margin="normal"
          value={formData.country}
          disabled
          onChange={handleInputChange("country")}
        >
          {countries.map((country) => (
            <MenuItem key={country} value={country}>
              {country}
            </MenuItem>
          ))}
        </TextField>
        {formData.origin === "indigene" && (
          <TextField
            select
            label="State of Origin"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.stateOfOrigin}
            onChange={handleInputChange("stateOfOrigin")}
          >
            {nigeriaStates.map((state) => (
              <MenuItem key={state} value={state}>
                {state}
              </MenuItem>
            ))}
          </TextField>
        )}
        {formData.origin === "citizen" && (
          <>
            <TextField
              label="State of resident"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.stateofresident}
              onChange={handleInputChange("stateofresident")}
            />
            <TextField
              label="State of Origin from the Origin Country"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.other_state}
              onChange={handleInputChange("other_state")}
            />
          </>
        )}
        <TextField
          select
          label="Local Government Area"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.lga}
          name="lga"
          onChange={handleInputChange("lga")}
        >
          {LGAlist.map((lga) => (
            <MenuItem key={lga} value={lga}>
              {lga}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Position"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.position}
          onChange={handleInputChange("position")}
        />
        <TextField
          label="Date Of Birth"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.dateOfBirth}
          type="date"
          InputLabelProps={{ shrink: true }}
          onChange={handleInputChange("dateOfBirth")}
        />
        <TextField
          label="NIN"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.nin}
          onChange={handleInputChange("nin")}
        />
        {formData.nin !== "" && <i>Capture NIN, is required *</i>}
        <TextField
          select
          label="Profession"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.profession}
          onChange={handleInputChange("profession")}
        >
          {Professons.map((profession) => (
            <MenuItem key={profession} value={profession}>
              {profession}
            </MenuItem>
          ))}
        </TextField>
        {formData.profession === "Other" && (
          <TextField
            label="Write name of the profession"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.other_profession}
            onChange={handleInputChange("other_profession")}
          />
        )}
        <TextField
          label="Home address"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.member_address}
          onChange={handleInputChange("member_address")}
        />
         {
          submitting ? (
            <Button disabled variant="contained" color="primary">
              Submitting...
            </Button>
          ) : (
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          )
         }
  
      </form>
    </>
  );
}
